import './trumbo/plugins/trumbowyg.youtube.js'

document.addEventListener('turbo:load', () => {
  const $editor = $('.faq-answer-editor')
  if (!$editor.length) return

  $editor.trumbowyg({
    svgPath: '/images/icons-trumbowyg.svg',
    resetCss: false,
    linkTargets: ['_blank'],
    btns: [
      ['viewHTML'],
      ['undo', 'redo'],
      ['strong', 'em', 'del'],
      ['link'],
      ['unorderedList', 'orderedList'],
      ['figcaption', 'youtube'],
      ['removeformat'],
    ],
    plugins: {
      figcaption: {
        serverPath: '/api/uploads',
        fileFieldName: 'file'
      }
    }
  })
})
